export class User {
  _id: string = '';
  firstName: string = '';
  lastName: string = '';
  email: string = '';
  phone: string = '';
  password: string = '';
  role: string = '';
  customAssignmentId: string = "";
  client: any = [];  
  options: {
    active: boolean;
    emailNotification: boolean,
    assignByFields: {
      active: boolean,
      options: {
        customer: { fields: string, ids: string }[],
        campaign: { fields: string, ids: string }[],
        form: { fields: string, ids: string }[]
      }
    }
  };

  getFullName() {
    return `${this.firstName} ${this.lastName}`;
  }

  deserialize(input: any) {
    Object.assign(this, input);
    this.password = '';
    return this;
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/user/user.model.ts